import React from 'react';
import PropTypes from 'prop-types';
import { captilizeString } from '../functionUtils';
import { Card, Typography } from '@mui/material';
import Button from '@material-ui/core/Button';
import ViewCareNewProvider from './ViewCareNewProvider';
import Label from '../type/Label';
const ViewCareMember = (props) => {
    const rawProviderName = props.selectedMember?.selectedMember?.providerName || '';
    const providerName = rawProviderName
        ? rawProviderName.split(',')
        : null;

    return (
        <>
            <div className="CareTeamLayoutSection">
                <a href='javascript:void(0)' onClick={props.handleGoBackClick()} className='quickLinksCustomText'><Label id="backToCareTeam"/></a>
                <Typography variant="h4" className="care-team-header">
                    <Label id='careTeamText'/> {props.name}
                </Typography>

                <div className="CareTeamCardSection">
                    {
                        providerName ?
                            <Card className="care-team-card">
                                <div id="care-team-card">
                                    <div className="care-team-details">
                                        <Typography
                                            variant="body1"
                                            className="care-member-relationship"
                                        > <Label id="PCPLabel" /> </Typography>
                                        <Typography
                                            variant="body1"
                                            className="care-team-physician-name"
                                        >{providerName.length > 1
                                            ? `Dr. ${captilizeString(providerName[1])} ${captilizeString(providerName[0])}`
                                            : `Dr. ${captilizeString(providerName[0])}`}</Typography>

                                    </div>
                                    <div className="care-team-details view-pcp-container">
                                        <Typography variant="caption" className="care-member-relationship-phone">
                                        <Button className="view-pcp-profile" href={`https://healthcare.ascension.org/find-care/provider/${props?.selectedMember?.selectedMember?.providerNpi}`} rel="noreferrer" target="_blank"  color="primary" variant="contained"><Label id='viewPcpText'/></Button>
                                           
                                        </Typography>
                                    </div>
                                </div>
                            </Card>
                            : ''
                    }

                </div>

                <ViewCareNewProvider selectedMember={props.selectedMember} memberAccountHeader={props.memberAccountHeader} />
            </div>
        </>
    );
};

ViewCareMember.propTypes = {
    handleGoBackClick: PropTypes.func,
    selectedMember: PropTypes.object,
    memberAccountHeader: PropTypes.string,
    name: PropTypes.string
};
export default ViewCareMember;
